import axios from 'axios';

export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_INFOS_LOAD = 'USER_INFOS_LOAD';

export const userLogin = (logininfos) => {
   return {
    type: USER_LOGIN_SUCCESS,
    payload: logininfos
   }    
};

export const doLogout = () => {
    return dispatch => {
        axios.get(`auth/logout`).then(res =>{
            dispatch({
                type: USER_LOGOUT,
            });
        });
    }  
};


export const userLogout = () => {
    return {
            type: USER_LOGOUT
    }
};